import { z } from "zod";
import { audienceMembersSchema } from "@event-planner/shared";

/**
 * Admin form schema for create/edit of a custom group (named, organizer-
 * managed audience under ADR-120). The Groups tab in the admin filters
 * to `name != null && system == false`, so this form only ever authors
 * that face of the audience primitive.
 *
 * `members.includedAudienceIds` is now wired (composition shipped with
 * ADR-120). Cycle detection + depth limit enforced server-side in the
 * createAudience / updateAudience callables.
 */
export const audienceFormSchema = z.object({
  name: z.string().min(1, "Name is required").max(60, "Name too long"),
  description: z.string().nullable(),
  members: audienceMembersSchema,
});

export type AudienceFormData = z.infer<typeof audienceFormSchema>;
